export default "__VITE_ASSET__B8jG5imm__"